<div id="dept-home-science" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Department of Home Science</h2>
    <p class="inner-lead mt-3">
      The Department of Home Science at Shah Satnam Ji Girls' College, Sirsa provides practical and theoretical knowledge in food &amp; nutrition, textile, interior design and child development. The department is equipped with a well-furnished Home Science Lab.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Courses Offered</h4>
    <ul class="inner-lead">
      <li>Home Science as a subject in BA</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Faculty</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Qualification</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Dr. Sunita Sihag</td><td>Ph.D</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Department Activities</h4>
    <ul class="inner-lead">
      <li>Painting Competition</li>
      <li>Festival of Colours Celebration</li>
      <li>Art &amp; Craft Workshop</li>
    </ul>

  </div>
</div>
